import { Injectable } from '@angular/core';
import { maxValue, minValue } from '@vendasta/auxiliary-data-components';
import AutoNumeric from 'autonumeric';
import { Observable, of } from 'rxjs';
import { DataFilterDisplayService } from '../../interface';

@Injectable({ providedIn: 'root' })
export class AuxiliaryDataCurrencyInputDisplayService implements DataFilterDisplayService {
  currencyCode = 'USD';

  initialize(currencyCode: string): void {
    if (this.currencyCode) {
      this.currencyCode = currencyCode;
    }
  }

  getDisplay(value: number | string): Observable<string> {
    if (value === '') {
      return of('');
    }
    value = Number(value);
    const displayValue = (value / 100).toFixed(2);
    const formattedPrice = AutoNumeric.format(displayValue, {
      maximumValue: maxValue.toString(),
      minimumValue: minValue.toString(),
    });
    return of(`<b>${this.currencyCode} ${formattedPrice}</b>`);
  }
}
